module.exports = __webpack_public_path__ + "img/h5-search.6dcc9db2.png";